// extracted by mini-css-extract-plugin
export default {"ShippingItem":"ShippingItem_ShippingItem__3ldld","PriceWrapper":"ShippingItem_PriceWrapper__6z-uw"};